<template>
  <div>
    <vue-table v-model="selected" :data="data" :headers="headers" :loading.sync="computedLoading"
               :props.sync="computedProps" class="contact-table" show-select @change="onPagination"
               @click:row="rowClicked">
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-select v-model="props.length" :items="perPage" :menu-props="{offsetY: true}" class="rounded-lg"
                      dense hide-details label="تعداد" outlined/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-text-field v-model="props.search" append-icon="mdi-magnify" class="rounded-lg"
                          clearable dense hide-details label="جستجو" outlined/>
          </v-col>

          <!--          <v-col class="pa-2 d-flex align-center" cols="12" lg="3" md="4">-->
          <!--            <custom-date-picker v-model="birthday.start" :max="maxStart" append-icon="mdi-calendar-month" class="flex"-->
          <!--                                dense format="YYYY-MM-DD" hide-details input-class="bd-start" label="تاریخ تولد از"-->
          <!--                                nullable outlined type="date" wrapper-class="rounded-lg" @input="changeBirthday"/>-->

          <!--            <v-btn v-if="!!birthday.start" class="mr-2" icon small-->
          <!--                   @click="() => {birthday.start = ''; changeBirthday()}">-->
          <!--              <v-icon>mdi-close-circle-outline</v-icon>-->
          <!--            </v-btn>-->
          <!--          </v-col>-->

          <!--          <v-col class="pa-2 d-flex align-center" cols="12" lg="3" md="4">-->
          <!--            <custom-date-picker v-model="birthday.end" :max="maxEnd" :min="birthday.start"-->
          <!--                                append-icon="mdi-calendar-month" class="flex" dense format="YYYY-MM-DD" hide-details-->
          <!--                                input-class="bd-end" label="تا تاریخ" nullable outlined type="date"-->
          <!--                                wrapper-class="rounded-lg" @input="changeBirthday"/>-->

          <!--            <v-btn v-if="!!birthday.end" class="mr-2" icon small @click="() => {birthday.end = ''; changeBirthday()}">-->
          <!--              <v-icon>mdi-close-circle-outline</v-icon>-->
          <!--            </v-btn>-->
          <!--          </v-col>-->

          <!--          <v-col v-if="can($route.meta.permission)" class="pa-2" cols="12" lg="3" md="4">-->
          <!--            <users-picker v-model="props.user_id" hide-details/>-->
          <!--          </v-col>-->

          <!--        <v-col v-if="can($route.meta.permission) && !!computedProps.user_id" class="pa-2" cols="12" lg="3" md="4">-->
          <!--          <v-select v-model="computedProps.phoen_tag" :items="tagItems" :menu-props="{offsetY: true}" class="rounded-lg"-->
          <!--                    clear-icon="mdi-close-circle-outline" clearable dense label="دفترچه تلفن" outlined/>-->
          <!--        </v-col>-->
        </v-row>
      </template>

      <template v-slot:image="{item}">
        <img :src="item.avatar || '/media/users/blank.webp'" alt="" class="pa-1 overflow-hidden rounded-pill"
             style="object-fit: cover;width: 44px;height: 44px"/>
      </template>

      <template v-slot:name="{item}">
        {{ !item.name && !item.lastName ? '-' : (item.name || '') + ' ' + (item.lastName || '') }}
      </template>

      <template v-slot:email="{item}">
        {{ item.email | getEmail }}
      </template>

      <template v-slot:phone="{item}">
        {{ item.phone }}

        <v-tooltip top>
          <template v-slot:activator="{on, attr}">
            <v-btn class="mx-1" icon small v-bind="attr" v-on="on"
                   @click.stop="copyLink(item.phone, false, 'شماره همراه کپی شد.')">
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>

          <span>کپی شماره</span>
        </v-tooltip>
      </template>

      <template v-slot:title="{item}">
        {{ !item.jobTitle && !item.companyName ? '-' : (item.jobTitle || '') + ', ' + (item.companyName || '') }}
      </template>

      <template v-slot:created_at="{item}">
        {{ datetime(item.created_at, 'datetime') }}
      </template>

      <template v-slot:tag="{item}">
        <v-chip v-for="(tag, i) in item.phone_tags" :key="i" class="rounded-lg" outlined small>
          {{ tag.name }}
        </v-chip>
      </template>

      <template v-slot:action="{item}">
        <contacts-buttons :data="item" @delete="deleteItem" @edit="rowClicked(item)"/>
      </template>
    </vue-table>

    <v-divider/>
    <contact-sends-pattern :items="selected" :table-props="tableProps"/>
  </div>
</template>

<script>
import {can} from "@/core/plugins/acl";
import UsersPicker from "@/core/plugins/TitleRibbon/pages/pickers/userPicker.vue"
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import ContactsButtons from "@/view/content/contacts/contactsButtons.vue";
import ContactSendsPattern from "@/view/content/contacts/contactSendsPattern.vue";

export default {
  name: "contactsTable",

  components: {ContactSendsPattern, ContactsButtons, CustomDatePicker, UsersPicker},

  filters: {
    getEmail(e) {
      if (typeof e === 'string') {
        let emails = JSON.parse(e);
        return !!emails?.length ? emails?.[0].email : '-'
      }

      if (e instanceof Array && !!e?.length) return e?.[0].email || '-';

      return '-'
    }
  },

  props: {
    value: Array,
    data: Object,
    tableProps: Object,
    loading: Boolean,
    tagItems: Array
  },

  data() {
    return {
      headers: [
        {value: 'image', text: 'عکس', sortable: false},
        {value: 'name', text: 'نام و نام‌خانوادگی', sortable: false},
        {value: 'email', text: 'ایمیل', sortable: false},
        {value: 'phone', text: 'شماره همراه', sortable: false},
        {value: 'title', text: 'عنوان شغلی و شرکت', sortable: false},
        {value: 'created_at', text: 'زمان ایجاد', sortable: false},
        {value: 'tag', text: 'دفترچه تلفن', sortable: false},
        {value: 'action', text: 'عملیات', sortable: false},
      ],
      birthday: {
        start: '',
        end: ''
      },
    }
  },

  computed: {
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    computedProps: {
      get() {
        return this.tableProps
      },
      set(val) {
        this.$emit('update:tableProps', val)
      }
    },
    computedLoading: {
      get() {
        return this.loading
      },
      set(val) {
        this.$emit('update:loading', val)
      }
    },
    maxStart() {
      const moment = require('moment')

      return !!this.birthday.end ? this.birthday.end : moment().format('YYYY-MM-DD')
    },
    maxEnd() {
      const moment = require('moment')

      return moment().format('YYYY-MM-DD')
    }
  },

  methods: {
    can,
    rowClicked(event) {
      this.$emit('select', event)
    },
    handleAction(e, state = 'default') {
      if (state !== "default") {
        let els = document.getElementsByClassName('laravel-vue-datatable-tbody-tr');
        if (!!els) {
          els.forEach((value, index) => {
            if (state && e.id === Number(value.childNodes[1]?.textContent))
              value.classList.add('tr-focused')
            else if (value.classList.contains('tr-focused'))
              value.classList.remove('tr-focused')
          })
        }
      } else {
        this[e.name](e.data)
      }
    },
    deleteItem(data) {
      this.computedLoading = true
      this.requestApiDeletePayamak(`contact/${data.id}`)
        .then(({data}) => {
          this.$emit('reload')
          this.$toast.success('با موفقیت حذف شد')
        })
        .catch(({response}) => {
          console.log('failed to delete contact: ', response)
          if (response?.data?.message) this.$toast.error(response.data.message)
        })
        .finally(() => this.computedLoading = false)
    },
    changeBirthday(e) {
      const moment = require('moment-jalaali')
      let birthday_start = !!this.birthday.start ? moment(this.birthday.start).format('jYYYY-jMM-jDD') : undefined
      let birthday_end = !!this.birthday.end ? moment(this.birthday.end).format('jYYYY-jMM-jDD') : undefined

      this.computedProps['birthday_start'] = birthday_start
      this.computedProps['birthday_end'] = birthday_end

      // this.$nextTick(() => {
      //   this.$emit('reload')
      // })
    },
    onPagination(e) {
      let props = {
        ...this.computedProps,
        ...e
      }

      this.$emit('reload', props)
    }
  },
};
</script>


<style scoped>
.contact-table >>> .laravel-vue-datatable-tbody-tr {
  transition: all .06s ease-out;
  cursor: pointer;
}

/*.contact-table >>> .laravel-vue-datatable-tbody-tr:not(.tr-focused) > :last-child div {*/
/*  visibility: hidden;*/
/*  transition: all .06s ease-out;*/
/*}*/

.contact-table >>> .laravel-vue-datatable-tbody-tr.tr-focused,
.contact-table >>> .laravel-vue-datatable-tbody-tr:hover {
  background-color: rgba(20, 103, 224, 0.2);
}

/*.contact-table >>> .laravel-vue-datatable-tbody-tr:hover > :last-child div {*/
/*  visibility: visible;*/
/*}*/

.contact-table >>> tr td {
  vertical-align: middle;
}
</style>